import { render, staticRenderFns } from "./EbNavbar.vue?vue&type=template&id=63b3d147"
import script from "./EbNavbar.vue?vue&type=script&lang=js"
export * from "./EbNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports